import { render, staticRenderFns } from "./FormPasswordRecovery.vue?vue&type=template&id=28634ca8&scoped=true&"
import script from "./FormPasswordRecovery.vue?vue&type=script&lang=js&"
export * from "./FormPasswordRecovery.vue?vue&type=script&lang=js&"
import style0 from "./FormPasswordRecovery.vue?vue&type=style&index=0&id=28634ca8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28634ca8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VIcon,VImg,VRow,VTextField})
